
import companyAdminApi from 'app/apis/company-admin';
import stripe          from 'app/apis/stripe';
import CadminSlx       from 'app/selectors/company-admin/';

const Types = {
  FETCH: 'CADMIN_BANKS_FETCH',
  DELETE: 'CADMIN_BANKS_DELETE',
  UPDATE: 'CADMIN_BANKS_UPDATE',
  GET: 'CADMIN_BANKS_GET',
};

const Actions = {

  fetch: (companyId) => {
    const promise = companyAdminApi.bankAccountsFetch(companyId);
    return { type: Types.FETCH, promise, _entities: ['bankAccounts'] };
  },

  delete: (bankAccountId) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = companyAdminApi.bankAccountsDelete(companyId, bankAccountId);
    return dispatch({ type: Types.DELETE, promise });
  },

  update: (bankAccountId, attrs) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = companyAdminApi.bankAccountsUpdate(companyId, bankAccountId, attrs);
    return dispatch({ type: Types.UPDATE, promise, _entities: ['bankAccount'] });
  },

  get: (bankAccountId) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = companyAdminApi.bankAccountsGet(companyId, bankAccountId);
    return dispatch({ type: Types.GET, promise, _entities: ['bankAccount'] });
  },

};

export {
  Types,
};

export default Actions;
